export const validatePassword = (value, dispatch, error, setError, ChangeUserDataReducer) => {
        if (!value) {
            setError({...error, password: 'La contraseña es obligatoria'});
        } else if (value.length < 8) {
            setError({...error, password: 'La contraseña debe tener al menos 8 caracteres'});
        } else if (!/[a-z]/.test(value)) {
            setError({...error, password: 'Debe contener al menos una letra minúscula'});
        } else if (!/[A-Z]/.test(value)) {
            setError({...error, password: 'Debe contener al menos una letra mayúscula'});
        } else if (!/\d/.test(value)) {
            setError({...error, password: 'Debe contener al menos un número'});
        } else if (!/[@$!%*?&]/.test(value)) {
            setError({...error, password: 'Debe contener al menos un caracter especial'});
        } else {
            setError('');
        }
        dispatch(ChangeUserDataReducer(value, "contrasenia"));
    };

    export const validateNameAndLastName = (value, fieldType, dispatch, error, setError, ChangeUserDataReducer) => {
        let errorMessage = '';
    
        if (!value) {
            errorMessage = fieldType === 'pernombre' ? 'El nombre es obligatorio' : 'El apellido es obligatorio';
        } else if (value.length < 2) {
            errorMessage = fieldType === 'pernombre' ? 'El nombre debe tener al menos 2 caracteres' : 'El apellido debe tener al menos 2 caracteres';
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
            errorMessage = fieldType === 'pernombre' ? 'El nombre solo puede contener letras y espacios' : 'El apellido solo puede contener letras y espacios';
        }
    
        setError({...error, [fieldType]: errorMessage});
    
        if (fieldType === 'pernombre') {
            dispatch(ChangeUserDataReducer(value, "pernombre"));
        } else {
            dispatch(ChangeUserDataReducer(value, "perapellidos"));
        }
    };


    export const validateEmail = (value, fieldType, dispatch, error, setError, ChangeUserDataReducer) => {
        let errorMessage = '';
    
        if (!value) {
            errorMessage = 'El correo es obligatorio';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            errorMessage = 'El correo no es válido';
        }
    
        setError({...error, [fieldType]: errorMessage});
    
        dispatch(ChangeUserDataReducer(value, fieldType));
    }

    export const validatePhone = (value, dispatch, error, setError, ChangeUserDataReducer) => {
        let errorMessage = '';
    
        if (!value) {
            errorMessage = 'El teléfono es obligatorio';
        } else if (!/^[\d\s+]+$/.test(value)) {
            errorMessage = 'El teléfono debe ser válido';
        } else if (value.replace(/\s+/g, '').length < 4) {
            errorMessage = 'El teléfono debe tener al menos 4 dígitos';
        }
    
        setError({...error, usutelefono: errorMessage});
    
        dispatch(ChangeUserDataReducer(value, "usutelefono"));
    } 


    export const validateArea = (value, dispatch, error, setError, ChangeUserDataReducer) => {
        let errorMessage = '';
    
        if (!value) {
            errorMessage = 'El área es obligatoria';
        } else if (value.length < 2) {
            errorMessage = 'El área debe tener al menos 2 caracteres';
        } else if (value.length > 30) {
            errorMessage = 'El área no puede tener más de 30 caracteres';
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
            errorMessage = 'El área solo puede contener letras y espacios';
        }
    
        setError({...error, usuarea: errorMessage});
    
        dispatch(ChangeUserDataReducer(value, "usuarea"));
    }
